<template>
<!-- 注意：此组件只能使用在elementUI中的el-form组件中 -->

<!--
  使用方法示例：
  import Item from '../../common/formitem/Formitem';
   <Item
      v-for='item in obj'  // 初始循环对象obj: [{num: 1,inputname: '样例输入1',outputname: '样例输出1',},],
      :key='item.num'
      :inputLable='item.inputname'   // lable名称
      :outputLable='item.outputname'  // lable名称
      @inputValue='getInputValue($event, itemForm, item.num)'   // 绑定获取input的值的公用方法（返回值，当前组件绑定的对象，对象属性）
      @outputValue='getOutputValue($event, itemForm, item.num)' // 绑定获取output的值的公用方法
    ></Item>

 -->
  <div>
    <el-form-item :label='inputLable'>
      <el-input
        type='textarea'
        autosize
        placeholder='请输入内容'
        v-model='itemForm.input'
        @change='getInputValue'
      >
      </el-input>
    </el-form-item>
    <el-form-item :label='outputLable'>
      <el-input
        type='textarea'
        autosize
        placeholder='请输入内容'
        v-model='itemForm.output'
        @change='getOutputValue'
      >
      </el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name:'elform_itme',
  props:{
    inputLable:{
      type:String,
      default:'样例输入'
    },
    outputLable:{
      type:String,
      default:'样例输出'
    }

  },
  data(){
    return{
      itemForm:{
        input:'',
        output:''
      }
    };
  },
  methods:{
    getInputValue(){
      this.$emit('inputValue',this.itemForm.input);
    },
    getOutputValue(){
      this.$emit('outputValue',this.itemForm.output);
    }
  }
};
</script>

<style>
</style>